import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AppConfig from "../../AppConfig";

// First, create the thunk
const fetchCompany = createAsyncThunk("company/fetchCompany", async () => {
  try {
    // Retrieve state from localStorage

    var result = await AppConfig.PostData(
      `account/ping`,
      "GET",
      null,
      false,
      false
    );
    if (result.status === 200) {
      let company = await result.json();
      return company;
    } else {
      return null;
    }
  } catch (error) {
    return [...error.message];
  }
});

const initialState = {
  company: {},
  isAuthenticated: false,
  error: "",
  loading: "idle", // 'idle' | 'pending' | 'succeeded' | 'failed'
};

export const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setCompany: (state, action) => {
      state.company = [...action.payload];
      state.error = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(fetchCompany.pending, (state) => {
        state.loading = "loading";
      })
      .addCase(fetchCompany.fulfilled, (state, action) => {
        state.loading = "succeeded";
        if (action.payload !== null) {
          state.company = action.payload;
          state.isAuthenticated = true;
        } else {
          localStorage.setItem('access_token', null);
          state.error = "Invalid login!";
        }
      })
      .addCase(fetchCompany.rejected, (state, action) => {
        state.loading = "failed";
        state.error = action.error.message;
      });
  },
});

// Action creators are generated for each case reducer function
export const { setError, setCompany } = companySlice.actions;
export { fetchCompany };

export default companySlice.reducer;
